import React from 'react';

import homeIcon from '../../../assets/icon/home.svg';
import homeIconActive from '../../../assets/icon/home-active.svg';
import diaryIcon from '../../../assets/icon/diary.svg';
import diaryIconActive from '../../../assets/icon/diary-active.svg';
import downloadIcon from '../../../assets/icon/download.svg';
import downloadIconActive from '../../../assets/icon/download-active.svg';

import './Pagination.scss';
import { sectionIds } from '../../../utils/constants';

const paginationConfig = [
  {
    name: 'home',
    icons: [homeIcon, homeIconActive],
    sections: [0],
    id: sectionIds.intro,
  },
  {
    name: 'diary',
    icons: [diaryIcon, diaryIconActive],
    sections: [1, 2, 3, 4, 5, 6, 7, 8],
    id: sectionIds.about,
  },
  {
    name: 'download',
    icons: [downloadIcon, downloadIconActive],
    sections: [9],
    id: sectionIds.download,
  },
];

export const Pagination = ({ activeSection }) => {
  const handleTabChange = (id) => {
    const section = document.getElementById(id);

    section.scrollIntoView({ behavior: 'instant' });
  };

  return (
    <div className="header-pagination">
      {paginationConfig.map(({ name, icons, sections, id }, i) => {
        const isActive = sections.includes(activeSection);

        return (
          <button
            key={`${i}`}
            className={`tab ${isActive ? 'tab-active' : ''}`}
            onClick={() => handleTabChange(id)}
          >
            <img alt={name} src={icons[0]} />
            <img alt={name} src={icons[1]} />
          </button>
        );
      })}
    </div>
  );
};

export default Pagination;
